import React, { Component } from 'react';

export class MensajeFinal extends Component {
    displayName = MensajeFinal.name

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            rechazo: this.props.location.state.rechazo,
            numeroGuia: this.props.location.state.numeroGuia,
            token: this.props.location.state.token,
            idPais: this.props.location.state.idPais,
            idCiudad: this.props.location.state.idCiudad,
            idDivision: this.props.location.state.idDivision,
            idModulo: this.props.location.state.idModulo,
            telefonoConfirma: this.props.location.state.telefonoConfirma,
            direccionConfirma: this.props.location.state.direccionConfirma,
            direccionAdicional: this.props.location.state.direccionAdicional,
            nombreConfirma:this.props.location.state.nombreConfirma,
            fechaConfirma: this.props.location.state.fechaConfirma,
            accionConfirma: this.props.location.state.accionGuardar,
            exito: false,
            data: null,
            mensajeFinal: '',
            funcion: this.props.location.state.funcion,

            confirmado: this.props.location.state.confirmado,
            vencido: this.props.location.state.vencido
        };
        console.log(this.state.idCiudad);
    }

    componentDidMount() {
        if (this.state.vencido == true) {

            fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + this.state.funcion + '/0/' + this.state.idModulo, {
                headers: {
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.numeroGuia
                }
            })
            .then(response => response.json())
            .then(data => {
                this.setState({ mensajeFinal: data, loading: false });
            });

        } else {
            if (this.state.confirmado != true) {
                let paso = '0';
                if (this.state.rechazo) {
                    paso = '400';
                } else {
                    paso = '200';
                }
                fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + this.state.funcion + '/' + paso + '/' + this.state.idModulo, {//paso 400 corresponde a rechazo
                    headers: {
                        'authorizedtoken': this.state.token,
                        'user': window.env.API_USER,
                        'refnumber': this.state.numeroGuia
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                        this.setState({ mensajeFinal: data });
                    });


                var confirmacionData = {
                    NUMERO_GUIA: this.state.numeroGuia,
                    ID_PAIS_ENTREGA_OFICINA: this.state.idPais,
                    ID_CIUDAD_ENTREGA_OFICINA: this.state.idCiudad,
                    ID_DIVISION_ENTREGA_OFICINA: this.state.idDivision,
                    CLIENTE_CANCELA_ENTREGA_ENVIO: this.state.rechazo,
                    DIRECCION: this.state.direccionConfirma,
                    DIRECCION_ADICIONAL: this.state.direccionAdicional,

                    TELEFONO_DESTINA_GUIA: this.state.telefonoConfirma,
                    NOMBRE: this.state.nombreConfirma,

                    ESTADO_ACTUALIZACION_DATOS: window.env.ESTADO_CONFIRMADO.filter(x => x.modulo == this.state.idModulo)[0].estado,
                    LOGIN_EMPLEADO_MODIFICACION: "Prueba",
                    FECHA_MODIFICACION: this.state.fechaConfirma,
                    ID_MODULO: this.state.idModulo,
                    ACCION: this.state.accionConfirma
                };
                var data = new FormData();
                data.append("json", JSON.stringify(confirmacionData));
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorizedtoken': this.state.token,
                        'user': window.env.API_USER,
                        'refnumber': this.state.numeroGuia
                    },
                    contentType: "application/json",
                    body: JSON.stringify(confirmacionData)

                };

                fetch(window.env.API_DOMAIN_ADDR + '/api/Confirmacion/Actualizar', requestOptions)
                    .then(response => response.json())
                    .then(dataRes =>

                        this.setState({
                            data: dataRes,
                            loading: false
                        })
                    );
            } else {
                this.setState({
                    loading: false
                })
            }
        }
    }

    renderMsjFinal(ctx) {
        if (this.state.vencido) {
            return ctx.renderVencido(this);
        } else {
            if (this.state.confirmado != true) {
                if (this.state.data.codigo == 200) {
                    if (this.state.rechazo == true) {
                        return ctx.renderRechazado(this);
                    } else {
                        return ctx.renderEnvio(this);
                    }
                } else {
                    return ctx.renderError();
                }
            } else {
                return ctx.renderConfirmado();
            }
        }
    } 

    static renderRechazado(c) {
        return (
            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                    <img className="movil-lanscape" src="/media/images/escritorio/fondo_bienvenido.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Confirmaciones_White.png" />
                    <div className="msjFinal" style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} >
                        <div>
                            <img src="/media/images/no_confirmado.png" />
                            <br />
                            <br />  
                            <label style={{ width: "85%" }}>{c.state.mensajeFinal.mensaje}</label>
                            <br />
                            <br />
                            <img className="logoRechazo" src="/media/images/Logo_servi.png" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    static renderVencido(c) {
        return (
            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                </div>
                <div className="content-full">
                    <div className="msjFinal" style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} >
                        <br />
                        <label style={{ width: "85%" }}>{c.state.mensajeFinal.mensaje}</label>
                    </div>
                </div>
            </div>
        );
    }

    static renderEnvio(c) {
        return (
            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                    <img className="movil-lanscape" src="/media/images/escritorio/fondo_bienvenido.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Confirmaciones_White.png" />
                    <div style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} className="msjFinal">
                        <div id="img_confirmado" style={{ width: "30%", float: "left" }}>
                            <img style={{ width: "100%" }} src="/media/images/Ex_onfirmado.png" />
                        </div>
                        <div id="msj_confirmado" style={{ width: "70%", float: "right", paddingRight: "1em" }}>
                            <img src="/media/images/confirmado.png" />
                            <label className="final_label">{c.state.mensajeFinal.mensaje}</label>
                            <label style={{ fontSize: "0.7em" }} className="final_label">Para cambiar la información registrada comunicarse al 7700 200</label>
                            <img className="logoEscritorio" src="/media/images/Logo_servi.png" />
                        </div>

                        <div id="img_confirmado_movil">
                            <img className="logoAcepta" src="/media/images/Logo_servi.png" />
                            <img className="expAcepta" src="/media/images/Ex_onfirmado.png" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    static renderError() {
        return (
            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Confirmaciones_White.png" />
                    <div style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} className="msjFinal">
                        <img src="/media/images/no_confirmado.png" />
                        <label className="final_label">Ha ocurrido un error durante la actualización de datos. Intentelo nuevamente</label>
                    </div>
                </div>
            </div>
        );
    }

    static renderConfirmado() {
        return (
            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                    <img className="movil-lanscape" src="/media/images/escritorio/fondo_bienvenido.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Confirmaciones_White.png" />
                    <div style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} className="msjFinal">
                        <div id="img_confirmado" style={{ width: "30%", float: "left" }}>
                            <img style={{ width: "100%" }} src="/media/images/Ex_onfirmado.png" />
                        </div>
                        <div id="msj_confirmado" style={{ width: "70%", float: "right", paddingRight: "1em" }}>
                            <img src="/media/images/confirmado.png" />
                            <label className="final_label">Información confirmada, próximamente recibirás el envío en la dirección ingresada.</label>
                            <label style={{ fontSize: "0.7em" }} className="final_label">Para cambiar la información registrada comunicarse al 7700 200</label>
                        </div>

                        <div id="img_confirmado_movil">
                            <img className="logoAcepta" src="/media/images/Logo_servi.png" />
                            <img className="expAcepta" src="/media/images/Ex_onfirmado.png" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let content = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderMsjFinal(MensajeFinal);

        return (
            <div>
                {content}
            </div>
        );
    }
}
